import React, { useContext, useState, useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';
// Components
// API
import { postProductAllocationTemplateImport } from '../../../api/productSamplingWorkflowApi';
// Context
import useAllocationContext from '../context/useAllocationContext';

export default function ImportModal() {
  const { plan, importModal, setImportModal, loadConfirmedInventoryList } =
    useContext(useAllocationContext);

  const importRequestDefault = {
    file: null,
  };
  const fileInputRef = useRef(null);
  const [importRequest, setImportRequest] = useState(importRequestDefault);
  const [importDetails, setImportDetails] = useState({});

  const handleCancel = () => {
    setImportModal({ ...importModal, toggle: false });
  };

  const handleChange = (e) => {
    setImportRequest({ ...importRequest, file: e.target.files[0] });
  };

  const handleSubmitImport = async () => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        plan_id: plan.plan_id,
        file: importRequest?.file,
        month: Number(moment(plan.effectivity_month, 'MMMM').format('M')),
        year: plan.effectivity_year,
      };
      const response = await postProductAllocationTemplateImport(request);
      const { code, message, data } = response.data;

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setImportRequest(importRequestDefault);

      if (code !== '200') {
        let messages = [];
        if (Array.isArray(data)) {
          messages = data.map((item) => `${item.column}`);
        } else if (data && typeof data === 'object') {
          messages = Object.entries(data).flatMap(([field, errors]) =>
            Array.isArray(errors) ? errors : [errors],
          );
        } else {
          messages = [message || 'Something went wrong.'];
        }
        Swal.fire({
          icon: 'error',
          title: 'Import Failed',
          width: 700,
          html: `
              <div style="text-align: left;">
                ${messages
                  .map(
                    (message) => `
                      <div style="
                        margin-bottom: 8px;
                        padding: 10px;
                        border: 1px solid #ddd;
                        border-radius: 6px;
                      ">
                        ${message}
                      </div>
                    `,
                  )
                  .join('')}
              </div>
            `,
        });
        throw new Error(message);
      }
      toast.dismiss();
      toast.success(message);
      setImportDetails(data);
      loadConfirmedInventoryList();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  return (
    <div>
      <Dialog open={importModal?.toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
        <DialogTitle>Product Sample Allocation Import</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid xs={12} md={12} lg={12} sx={{ padding: 2 }}>
              <Box sx={{ fontWeight: 'bold', color: 'red' }}>
                {' '}
                Effectivity Date: {plan?.effectivity_month} {plan?.effectivity_year}
              </Box>

              <Box sx={{ fontWeight: 'bold', color: 'red' }}>
                {' '}
                Inserted: {importDetails?.inserted ?? 0} Updated: {importDetails?.updated ?? 0}
              </Box>
            </Grid>

            <Grid xs={12} md={12} lg={12}>
              <Box component='form' noValidate autoComplete='off'>
                <TextField
                  type='file'
                  id='file'
                  name='file'
                  onChange={(e) => handleChange(e)}
                  size='small'
                  fullWidth
                  style={{ marginTop: '10px' }}
                  inputRef={fileInputRef}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='success' onClick={handleSubmitImport}>
            Import
          </Button>
          <Button variant='contained' color='error' onClick={handleCancel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
